// The account this device last authenticated as, held in memory and fed by
// App's single auth-state subscription (src/App.tsx). No imports, no side
// effects: a module that only reads it never starts a Supabase client.
//
// Why it exists. A phone that has been out of signal for longer than the
// access token's lifetime cannot refresh it. auth-js then answers getSession()
// with NO session plus the network error, yet it KEEPS the stored session: only
// a non-retryable refresh failure removes it, and that removal emits SIGNED_OUT
// (clearing this memory) before getSession returns. So "getSession failed and
// an identity is remembered" means exactly "still signed in here, just
// offline". A report queued at that moment binds to that account and drains
// once the same login can refresh again. Nothing is granted by this: the server
// re-checks the principal on every replay.
type AuthEventSession = {user?: {id?: unknown} | null} | null | undefined;

let lastUserId: string | null = null;

export function rememberAuthIdentity(event: string, session: AuthEventSession): void {
  if (event === 'SIGNED_OUT') {
    lastUserId = null;
    return;
  }
  const id = session?.user?.id;
  if (typeof id === 'string' && id) lastUserId = id;
}

export function lastAuthenticatedUserId(): string | null {
  return lastUserId;
}
